import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

export interface ErrorDialogData {
    message: string;
    details?: string;
}

@Component({
    selector: 'admin-error-dialog',
    templateUrl: 'error-dialog.component.html',
    styleUrls: ['error-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton],
})
export class ErrorDialogComponent {
    dialogRef = inject<MatDialogRef<ErrorDialogComponent>>(MatDialogRef);
    data = inject<ErrorDialogData>(MAT_DIALOG_DATA);


    ok(): void {
        this.dialogRef.close();
    }
}
